<div class="card">
  <div class="card-header">
    <span class="card-title"> {{ title }} </span>
    <p>
      {{ subTitle }}
    </p>
    <button mat-mini-fab class="closex" color="warn" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="h-100 d-flex align-items-center" mat-dialog-content>
        <span class="message-body" [innerHTML]="message"></span>
      </div>
      <!-- </div> -->
    </div>
  </div>
  <div class="card-footer">
    <p>
      {{ footer }}
    </p>
  </div>
</div>
